import * as React from 'react';

import {Body} from 'shells/typography/body';

export function SavedBanner() {
    return <Body color='green'>Changes to this calendar event have been updated</Body>;
}
